import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { IEmpresa, ITipo } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { TipoService } from "../../../services/catalogos/tipo/tipo.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoTipooStatus } from "../../../states/admon-catalogos/selector";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";

@Component({
  selector: "app-nuevo-tipo",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./nuevo.component.html",
  styleUrl: "./nuevo.component.css",
})
export class NuevoTipoComponent {
  @Output() mostrarBotones: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() tipos: ITipo[] = [];
  @Input() empresas: IEmpresa[] = [];
  private store: Store<AppState> = inject(Store);
  private loadingService = inject(LoadingService);
  admonCatTiposStatus$ = this.store.pipe(select(selectCatalogoTipooStatus));

  descripcion = "";
  existe = false;

  nuevoRegistro!: FormGroup;

  constructor(private fb: FormBuilder, private tipoService: TipoService) {}

  ngOnInit() {
    this.init();
  }
  init() {
    this.nuevoRegistro = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
         descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });
  }

  nuevoTipo() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "tipos",
        mostrarEditar: false,
        mostrarNuevo: true,
        guardando: false,
      })
    );
  }

  cancelar() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "tipos",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
    this.init();
  }
  guardarRegistro() {
    this.loadingService.show();
    if (this.nuevoRegistro.valid) {
      this.tipoService
        .guardarTipo(this.nuevoRegistro.value.descripcion)
        .subscribe((data) => {
          if (!data.error) {
            this.cancelar();
          }
          this.loadingService.hide();
        });
    }
  }

  ocultarBotones(ocultar: boolean) {
    this.mostrarBotones.emit(ocultar);
  }

  existeRegistro(control: any, currentValue: any): void {
    existeValorDuplicado(control, this.tipos, currentValue);
  }
}
